import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class ToolbarService {
  public activeView$ = new BehaviorSubject<string>('');
  public summaryView$ = new BehaviorSubject<number>(null);
  public paymentSummary$ = new BehaviorSubject<number>(null);
  constructor() {}

  setViewActive(view: string): void {
    this.activeView$.next(view);
  }

  getViewActive(): Observable<string> {
    return this.activeView$;
  }

  setSummaryView(summary: number): void {
    this.summaryView$.next(summary);
  }

  getSummaryView(): Observable<number> {
    return this.summaryView$;
  }

  setPaymentSummary(paymentSummary: number): void {
    this.paymentSummary$.next(paymentSummary);
  }

  getPaymentSummary(): Observable<number> {
    return this.paymentSummary$;
  }
}
